export default class BusinessModelService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/business_models/' + id, params)
	}

	createEntity(params){
		return this.apiService.callPost('me/business_models', params);
	}

	updateEntity(id, params) {
		return this.apiService.callPut('me/business_models/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/business_models/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('me/business_models', params)
	}

	getEntitiesForSelectBox(params) {
		return this.apiService.callGet('me/business_models/simple', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/BusinessModelService.js